import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Select } from '@99designs/common/components/Select';
import { FieldSet, Field } from 'common/components/Form';
import connectToStores from 'fluxible-addons-react/connectToStores';
import BookCalculatorAttributesStore from 'book-calculator/stores/BookCalculatorAttributesStore';
import BookCalculatorFieldOptionStore from 'book-calculator/stores/BookCalculatorFieldOptionStore';
import { handleUpdatedAttribute } from 'book-calculator/actions/handleUpdatedAttribute';

class PrintingFieldset extends React.Component {
    handleUpdateAttribute(key, value) {
        this.context.executeAction(handleUpdatedAttribute, {
            key: key,
            value: value,
        });
    }

    render() {
        const {
            pageCount,
            pageCountOptions,
            dimensions,
            dimensionsOptions,
            materialCost,
            materialCostOptions,
            quantity,
            quantityOptions,
            colored,
            coloredOptions,
        } = this.props;

        return (
            <FieldSet twoColumn={false}>
                <div className="row">
                    <div className="column small-12 medium-6 normal-6 large-6">
                        <Field
                            title={<FormattedMessage id="fields.quantity.label" />}
                            variations={['jumbo-title']}
                        >
                            <Select
                                onChange={({ value }) => {
                                    this.handleUpdateAttribute('quantity', parseInt(value, 10));
                                }}
                                name={'quantity'}
                                value={quantity}
                                options={quantityOptions}
                            />
                        </Field>
                    </div>
                    <div className="column small-12 medium-6 normal-6 large-6">
                        <Field
                            title={<FormattedMessage id="fields.page_count.label" />}
                            variations={['jumbo-title']}
                        >
                            <Select
                                onChange={({ value }) => {
                                    this.handleUpdateAttribute('page_count', parseInt(value, 10));
                                }}
                                name={'page_count'}
                                value={pageCount}
                                options={pageCountOptions}
                            />
                        </Field>
                    </div>
                </div>

                <div className="row">
                    <div className="column small-12 medium-6 normal-6 large-6">
                        <Field
                            title={<FormattedMessage id="fields.dimensions.label" />}
                            variations={['jumbo-title']}
                        >
                            <Select
                                onChange={({ value }) => {
                                    this.handleUpdateAttribute('dimensions', value);
                                }}
                                name={'dimensions'}
                                value={dimensions}
                                options={dimensionsOptions}
                            />
                        </Field>
                    </div>
                    <div className="column small-12 medium-6 normal-6 large-6">
                        <Field
                            title={<FormattedMessage id="fields.material_cost.label" />}
                            variations={['jumbo-title']}
                        >
                            <Select
                                onChange={({ value }) => {
                                    this.handleUpdateAttribute(
                                        'material_cost',
                                        parseFloat(value, 10)
                                    );
                                }}
                                name={'material_cost'}
                                value={materialCost}
                                options={materialCostOptions}
                            />
                        </Field>
                    </div>
                </div>

                <div className="row">
                    <div className="column">
                        <Field
                            title={<FormattedMessage id="fields.colored.label" />}
                            variations={['jumbo-title']}
                        >
                            <Select
                                onChange={({ value }) => {
                                    this.handleUpdateAttribute('colored', value);
                                }}
                                name={'colored'}
                                variations={['max']}
                                value={colored}
                                options={coloredOptions}
                            />
                        </Field>
                    </div>
                </div>
            </FieldSet>
        );
    }
}

PrintingFieldset.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

PrintingFieldset.propTypes = {
    pageCount: PropTypes.number.isRequired,
    pageCountOptions: PropTypes.array.isRequired,
    dimensions: PropTypes.string.isRequired,
    dimensionsOptions: PropTypes.array.isRequired,
    materialCost: PropTypes.number.isRequired,
    materialCostOptions: PropTypes.array.isRequired,
    quantity: PropTypes.number.isRequired,
    quantityOptions: PropTypes.array.isRequired,
    colored: PropTypes.string.isRequired,
    coloredOptions: PropTypes.array.isRequired,
};

export default connectToStores(
    PrintingFieldset,
    [BookCalculatorAttributesStore],
    (context, prop) => {
        const attributes = context.getStore(BookCalculatorAttributesStore).getState();
        const options = context.getStore(BookCalculatorFieldOptionStore).getOptions();

        return {
            pageCount: attributes['page_count'],
            pageCountOptions: options['page_count'],
            dimensions: attributes['dimensions'],
            dimensionsOptions: options['dimensions'],
            materialCost: attributes['material_cost'],
            materialCostOptions: options['material_cost'],
            quantity: attributes['quantity'],
            quantityOptions: options['quantity'],
            colored: attributes['colored'],
            coloredOptions: options['colored'],
        };
    }
);
